export default __webpack_public_path__ + "62e13adc28053aaf23c92470b2c7366a.png";